module.exports = __webpack_public_path__ + "static/media/main-logo.552c0e7d.svg";